import {
  CreatedUpdateByOptionEnumLabels,
  CreatedUpdatedByOptionEnum
} from '@/bundles/GroupFilters/enums/flex/CreatedUpdatedByOptionEnum';
import { getDisplayNameWithCount } from '@/bundles/GroupFilters/helpers/formatters/names/getDisplayNameWithCount';

export interface ICreatedUpdatedByUserValue {
  name: string;
  id: number;
}

export type CreatedUpdatedByFilterValue = ICreatedUpdatedByUserValue[] | [CreatedUpdatedByOptionEnum];

export const isUserValueArray = (value: CreatedUpdatedByFilterValue): value is ICreatedUpdatedByUserValue[] => {
  const firstValue = value[0];
  return typeof firstValue === 'object' && firstValue !== null && 'id' in firstValue;
};

export const getCreatedUpdatedBySelectFormattedValue = (value: CreatedUpdatedByFilterValue): string => {
  if (isUserValueArray(value)) {
    return getDisplayNameWithCount(value, 'member');
  }

  return CreatedUpdateByOptionEnumLabels[value[0]] ?? '';
}
